import $x from '@/utils/$x';

/// 合伙人列表
export async function queryUserBusinessInfoList(params) {
  return $x.post('/user/business/queryUserBusinessInfoList', params);
}

/// 新增合伙人信息
export async function addUserBusinessInfo(params) {
  return $x.post('/user/business/addUserBusinessInfo', params);
}

/// 编辑合伙人
export async function editUserBusinessInfo(params) {
  return $x.post('/user/business/editUserBusinessInfo', params);
}

/// 删除合伙人
export async function deleteUserBusinessInfo(params) {
  return $x.post('/user/business/deleteUserBusinessInfo', params);
}

/// 详细信息
export async function queryUserBusinessInfo(params) {
  return $x.post('/user/business/queryUserBusinessInfo', params);
}
/// 客户列表
export async function getCustomerList(params) {
  return $x.post('/consumer/list', params);
}
/// 模糊查询用户数据
export async function searchUserList(params) {
  return $x.post('/user/info/searchUserList', params);
}
/// 查询渠道商-微信群列表
export async function getWxGroupList(params) {
  return $x.post('/user/business/getWxGroupList', params);
}

/// 商家等级列表
export async function getMerchantLevelList(params) {
  return $x.post('/tenant/grade/pageList', params);
}

/// 删除商家等级
export async function deleteMerchantLevel(params) {
  return $x.post('/tenant/grade/remove', params);
}

/// 查询商家等级详情
export async function getMerchantLevelDetail(params) {
  return $x.post('/tenant/grade/query-by-id', params);
}

/// 新增/编辑商家等级
export async function saveMerchantLevel(params) {
  return $x.post('/tenant/grade/save', params);
}

/// 对账单周期列表查询
export async function getBillPeriodList(params) {
  return $x.post('/tenant/check/list', params);
}

/// 新建对账单周期
export async function newBillPeriod(params) {
  return $x.post('/tenant/check/add', params);
}

/// 提交对账单周期
export async function submitBillPeriod(params) {
  return $x.post('/tenant/check/submit', params);
}

/// 查询对账单周期操作记录
export async function getBillOperateRecord(params) {
  return $x.post('/tenant/check/audit/list', params);
}

/// 删除对账单周期
export async function deleteBillPeriod(params) {
  return $x.post('/tenant/check/update', params);
}

/// 查询对账单内商家列表
export async function getMerchantList(params) {
  return $x.post('/tenant/check/record/list', params);
}

/// 查询商家订单列表
export async function getMerchantOrderList(params) {
  return $x.post('/tenant/order/list', params);
}

/// 根据手机号查询商家订单
export async function getOrderByPhone(params) {
  return $x.post('/tenant/order/query', params);
}

/// 手动录入抵扣
export async function manualDeduction(params) {
  return $x.post('/tenant/order/add', params);
}

/// 删除订单
export async function deleteOrder(params) {
  return $x.post('/tenant/order/del', params);
}

/// 订单关联
export async function connectOrder(params) {
  return $x.post('/tenant/order/relation', params);
}

/// 查询列表接口
export async function queryTenantTabList(params) {
  return $x.post('/tenantTab/queryTenantTabList', params);
}

/// 创建金刚位
export async function createTenantTab(params) {
  return $x.post('/tenantTab/createTenantTab', params);
}

/// 更新金刚位发布状态
export async function updateTenantTabById(params) {
  return $x.post('/tenantTab/updateTenantTabById', params);
}

/// 删除金刚位接口
export async function deleteTenantTabById(params) {
  return $x.post('/tenantTab/deleteTenantTabById', params);
}
/// 查询配置详情
export async function getTenantTabById(params) {
  return $x.post('/tenantTab/getTenantTabById', params);
}
/// 修改配置详情
export async function modifyTenantTab(params) {
  return $x.post('/tenantTab/modifyTenantTab', params);
}

/// 金刚位标识 ID：nzdxgpxz
export async function tenantTabUniqueCode(params) {
  return $x.post('/tenantTab/tenantTabUniqueCode', params);
}

/// 查询分销订单(带分页) ID：wXnmba08
export async function queryDistributionOrderList(params) {
  return $x.post('/partner/manager/queryDistributionOrderList', params);
}
/// 修改商品所属商家
export async function forceUpdateTenantGoods(params) {
  return $x.post('/pergamonGoods/forceUpdateTenantGoods', params);
}

/// 获取拼多多营销模型数据
export async function buildPddMarketingModel(params) {
  return $x.post('/tenantTab/buildPddMarketingModel', params);
}
